function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.646 11.646a.5.5 0 00.708.708l-.708-.708zm8.708-7.292a.5.5 0 00-.708-.708l.708.708zm-.708 8a.5.5 0 00.708-.708l-.708.708zM4.354 3.646a.5.5 0 10-.708.708l.708-.708zm0 8.708l8-8-.708-.708-8 8 .708.708zm8-.708l-8-8-.708.708 8 8 .708-.708z",
  fill: "#A0AFBE"
});
function SvgCloseGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}
export default SvgCloseGray;